import React, { useState, useRef, useEffect } from 'react';

const BeautyButton = ({ 
  icon: Icon, 
  text, 
  description, 
  children, 
  showCloseButton = true,
  backgroundImage = null, // optional background image for popup
  linkUrl = null, // optional link button URL
  linkText = "Learn More", // optional link button text
  ...props 
}) => {
  const [isContentVisible, setIsContentVisible] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const popupRef = useRef(null);

  const handleOpenPopup = () => setIsPopupOpen(true);
  const handleClosePopup = () => setIsPopupOpen(false);
  const toggleContent = () => setIsContentVisible(!isContentVisible);

  const handleClick = () => {
    if (props.type === 'popup' || props.type === 'account') {
      handleOpenPopup();
    } else if (props.type === 'dropdown') {
      toggleContent();
    }
  };

  // Close popup when clicking outside
  useEffect(() => {
    function handleOutsideClick(event) {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsPopupOpen(false);
      }
    }
    if (isPopupOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isPopupOpen]);

  let icon_url;
  if (props.iconType === 'plus') {
    icon_url = '/assets/images/icons/plus.svg';
  } else if (props.iconType === 'add') {
    icon_url = '/assets/images/icons/add.svg';
  } else if (props.iconType === 'like') {
    icon_url = '/assets/images/icons/like.svg';
  } else if (props.iconType === 'save') {
    icon_url = '/assets/images/icons/save.svg';
  } else {
    icon_url = '/assets/images/icons/info.svg';
  }

  return (
    <>
      <button
        className="main-container flex w-auto h-[34px] pt-[6px] pr-[13px] pb-[6px] pl-[13px] gap-[14px] 
          items-center flex-nowrap rounded-[30px] border-solid border-2 border-[#5f40a1] 
          relative ml-0 my-0 cursor-pointer"
        onClick={handleClick}
        {...props}
      >
        <div
          className="w-[16px] h-[16px] shrink-0 bg-contain bg-no-repeat relative"
          style={{ backgroundImage: `url(${icon_url})` }}
        />
        <span className="h-[17px] shrink-0 basis-auto text-[14px] font-semibold leading-[17px] text-[#5f40a1] relative text-left whitespace-nowrap z-[1]">
          {text}
        </span>
      </button>

      {isPopupOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div
            ref={popupRef}
            className="bg-[#E9A969] rounded-lg shadow-lg p-6 max-w-md w-full relative"
            style={{
              backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              color: backgroundImage ? '#fff' : 'inherit'
            }}
          >
            <h3 className="text-xl font-bold mb-4">{text}</h3>
            <p className="mb-6">{description}</p>
            {children}

            {/* Optional link button */}
            {linkUrl && (
              <a
                href={linkUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="block mt-4 bg-[#5F40A1] text-white px-4 py-2 rounded-full text-center hover:bg-[#2D1735] transition-colors duration-200"
              >
                {linkText}
              </a>
            )}

            {/* Optional close button */}
            {showCloseButton && (
              <button
                onClick={handleClosePopup}
                className="all-[unset] box-border relative w-full h-auto cursor-pointer group mt-4"
              >
                <div className="relative w-[100px] h-[40px] rounded-[50px] border-2 border-solid border-[#5F40A1] group-hover:border-[#2D1735] transition-colors duration-200 flex items-center justify-center">
                  <span className="text-[#5F40A1] group-hover:text-[#2D1735] transition-colors duration-200 font-normal text-[18px]">
                    Close
                  </span>
                </div>
              </button>
            )}
          </div>
        </div>
      )}

      {props.type === 'dropdown' && isContentVisible && (
        <div
          className="absolute z-10 mt-2 w-auto rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
          style={{ top: '100%', left: '0' }}
        >
          {children}
        </div>
      )}
    </>
  );
};

export default BeautyButton;
